<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import store from "../../store";
    import {bus} from "../../vue_bus";
    import {threeMain} from "../../threeJS/threeMain";

    export default {
        name: "WorkspaceFabric.vue",
        mixins: [urlForFileStorage],
        async mounted() {
            this.editor = new fabricEditor(this.$refs["fabricJS"]);
            this.editor.updateCanvaSize({
                    width: this.$refs["fabricJSContainer"].offsetWidth,
                    height: this.$refs["fabricJSContainer"].offsetHeight
                }
            )
            let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
            this.editor.addSetScale();
            this.editor.setViewport(source, 1);
            bus.$on("ScaleLineIsDrawn", () => {
                this.$router.replace({name: "SetScaleDistance"}).catch(() => {
                });
            })
        },
        destroyed() {
            this.editor.destroy();
            bus.$off("ScaleLineIsDrawn");
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            }
        },
        methods: {}
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
